import { Fragment, useEffect, useRef, useState } from "react";
import "./productDetailsEditComponent.css";
import {
  Button,
  ConfigProvider,
  Form,
  Input,
  InputNumber,
  Space,
  Switch,
  notification,
  Modal,
  Select,
  Checkbox,
} from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import type { FormInstance } from "antd/es/form";
import { useShowBoxContext } from "../../context/boxRestaurantContext";
import type { NotificationPlacement } from "antd/es/notification/interface";
import plusIcon from "../../icons/plusIcon.svg";
import secureLocalStorage from "react-secure-storage";
import { LoadingOutlined } from "@ant-design/icons";
import {
  update_product_restaurant,
  listProductRestaurant,
  listProductCategories,
  listRestaurantShowcases,
  getInfosShowCaseProduct,
  updateProductShowCase,
} from "../../services/products";
import { UploadFile } from "../../services/file";
import React from "react";
import CreateProductComponent from "../createProductComponent/createProductComponent";
import { start } from "repl";

export default function ProductEditComponent({
  productSelect,
  productShowCaseId,
  isOpen,
}: {
  productSelect: any;
  productShowCaseId?: number;
  isOpen: boolean;
}) {
  const [itemImage, setItemImage] = useState<any>(null);
  const [itemImageLoading, setItemImageLoading] = useState<boolean>(false);
  const { isEdit } = useShowBoxContext();
  const [loadInfoShowcase, setLoadInfoShowcase] = useState<boolean>(false);
  const [showcaseData, setShowCaseData] = useState<any>({});
  const [selectedAdditional, setSelectedAdditional] = useState("");
  const [selectedComplement, setSelectedComplement] = useState("");
  const [isBlocked, setIsBlocked] = useState<boolean>(false);
  const [formIsEnable, setFormIsEnable] = useState<boolean>();
  const [Formins] = Form.useForm();
  const days = [
    { value: 1, label: "Segunda-feira" },
    { value: 2, label: "Terça-feira" },
    { value: 3, label: "Quarta-feira" },
    { value: 4, label: "Quinta-feira" },
    { value: 5, label: "Sexta-feira" },
    { value: 6, label: "Sábado" },
    { value: 7, label: "Domingo" },
  ];
  const [api, contextHolder] = notification.useNotification();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const fileInputleRef = useRef(null);
  const [additionalsProducts, setAdditionalsProducts] = useState<any[]>([]);
  const [complementsProducts, setComplementsProducts] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>([]);

  const openNotificationSuccess = (
    placement: NotificationPlacement,
    values: any
  ) => {
    api.success({
      message: `Operação concluída com sucesso!`,
      description: `${values.name} foi modificado com sucesso`,
      placement,
      duration: 3.5,
    });
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  const openNotificationError = (placement: NotificationPlacement) => {
    api.error({
      message: `Operação fracassada`,
      description: `Por favor, verifique as informações inseridas`,
      placement,
      duration: 3,
    });
  };

  const stylesInput = {
    borderColor: "#6A2A40",
  };
  function getInfosShowcase() {
    setLoadInfoShowcase(true);
    console.log("productSelect", productShowCaseId);
    getInfosShowCaseProduct({ showcaseId: productShowCaseId })
      .then((response: any) => {
        console.log("response", response);
        setShowCaseData(response);
        setLoadInfoShowcase(false);
      })
      .catch((error: any) => {
        console.error("Erro ao buscar informações da vitrine:", error);
        setLoadInfoShowcase(false);
      });
  }
  useEffect(() => {
    if (isEdit) {
      Formins.setFieldsValue(productSelect);
      setItemImage(productSelect.picture);
      getInfosShowcase();
    } else {
      setItemImage(null);
      Formins.resetFields();
    }
  }, [isEdit, productSelect, Formins]);

  useEffect(() => {
    async function fetchCategories() {
      try {
        const data = await listProductCategories({});
        setCategories(data.items);
      } catch (error) {
        console.error("Erro ao carregar categorias:", error);
      }
    }

    fetchCategories();
  }, []);

  const onFinish = async (values: any) => {
    const restaurantId = secureLocalStorage.getItem("restaurant") as string;
    const user_id = secureLocalStorage.getItem("user_id");
    if (!restaurantId) {
      openNotificationError("top");
      setLoading(false);
      return;
    }

    const mappedAdditionals = values.additionals?.map((item: any) => ({
      product_id: productSelect.id,
      additional_or_complement_id: item.id,
      restaurant_id: restaurantId,
      price: item.price,
      status: item.status,
      product_type: item.product_type || "additional",
    }));

    const mappedComplements = values.complements?.map((item: any) => ({
      product_id: productSelect.id,
      additional_or_complement_id: item.id,
      price: item.price,
      restaurant_id: restaurantId,
      status: item.status,
      product_type: item.product_type || "complement",
    }));

    const payload = {
      ...values,
      modified_by: user_id,
      modified_at: new Date().toISOString(),
      restaurant_id_edition: parseInt(restaurantId),
      additionals: mappedAdditionals,
      complements: mappedComplements,
    };

    delete payload.additionais;
    delete payload.complementos;
    try {
      await update_product_restaurant({
        productId: productSelect.id,
        requestBody: payload,
      });
      await updateProductShowCase({
        showcaseId: productShowCaseId,
        requestBody: showcaseData,
      })
      console.log("request body:", payload);
      openNotificationSuccess("top", values);
    } catch (error: any) {
      console.error(
        "Erro ao atualizar o produto",
        error.response?.data || error
      );
      openNotificationError("top");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    openNotificationError("top");
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCheckboxChange = (value: any, checked: boolean) => {
    let next;

    if (checked) {
      next = [...showcaseData.weekday, value];
    } else {
      next = showcaseData.weekday.filter((item: any) => item !== value);
    }

    setShowCaseData({ ...showcaseData, weekday: next });
  };

  const loadAdditionalAndComplementsProducts = async () => {
    try {
      const [responseAdditionals, responseComplements] = await Promise.all([
        listProductRestaurant({ limit: 1000, offset: 0, type: "additional" }),
        listProductRestaurant({ limit: 1000, offset: 0, type: "complement" }),
      ]);
      setAdditionalsProducts(responseAdditionals.items);
      setComplementsProducts(responseComplements.items);
    } catch (error) {
      console.error(
        "Erro ao carregar produtos adicionais e complementos:",
        error
      );
    }
  };

  function validatedOptionDisabled(item: any) {
    const complements = Formins.getFieldValue("complements") || [];
    const additionals = Formins.getFieldValue("additionals") || [];
    const items = [...complements, ...additionals];
    const filtered =
      items.filter((product: any) => product.id === item.id).length > 0;
    return filtered;
  }

  useEffect(() => {
    loadAdditionalAndComplementsProducts();
  }, []);

  const onChangeSelect = (
    event: React.ChangeEvent<HTMLSelectElement>,
    type: "additional" | "complement"
  ) => {
    const selectedValue = event.target.value;

    if (type === "additional") {
      setSelectedAdditional(selectedValue);

      const selectedProduct = additionalsProducts.find(
        (product) => product.id === parseInt(selectedValue)
      );

      if (selectedProduct) {
        Formins.setFieldsValue({
          additionals: [
            ...Formins.getFieldValue("additionals"),
            selectedProduct,
          ],
        });
        setSelectedAdditional("");
      }
    } else if (type === "complement") {
      setSelectedComplement(selectedValue);

      const selectedProduct = complementsProducts.find(
        (product) => product.id === parseInt(selectedValue)
      );

      if (selectedProduct) {
        Formins.setFieldsValue({
          complements: [
            ...Formins.getFieldValue("complements"),
            selectedProduct,
          ],
        });
        setSelectedComplement("");
      }
    }
  };

  function handleUploadImageProfile(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      setItemImage(null);
      setItemImageLoading(true);

      UploadFile({ file: selectedFile })
        .then((response) => {
          const imageUrl = response.path || response.data.path;
          if (!imageUrl) {
            throw new Error("Erro ao obter o caminho da imagem");
          }

          setItemImage(imageUrl);
          Formins.setFieldsValue({ picture: imageUrl });
          setItemImageLoading(false);
        })
        .catch((error) => {
          console.error("Erro ao fazer upload da imagem:", error);
          setItemImageLoading(false);
        });
    }
  }

  return (
    <>
      <h3>Editar Produto</h3>
      {contextHolder}
      <Form.Provider>
        <Form
          name="basic"
          onFinish={onFinish}
          form={Formins}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          disabled={isBlocked}
        >
          <Form.Item
            name="picture"
            label="Imagem do Item"
            rules={[
              { required: false, message: "Por favor, carregue uma imagem" },
            ]}
          >
            <div
              style={{
                display: "flex",
                borderRadius: 20,
                border: "3px dotted #6A2A40",
                width: "350px",
                justifyContent: "center",
                alignItems: "center",
                height: "250px",
                padding: "5px",
                cursor: "pointer",
              }}
              //@ts-ignore
              onClick={() => fileInputleRef.current.click()}
            >
              {itemImage ? (
                <>
                  <img
                    src={itemImage}
                    alt="imagem do produto"
                    className="image-profile"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      borderRadius: 20,
                    }}
                  />
                </>
              ) : (
                <>
                  {itemImageLoading ? (
                    <LoadingOutlined rev={undefined} />
                  ) : (
                    <h2
                      style={{
                        minWidth: "100%",
                        minHeight: "100%",
                        borderRadius: 20,
                        background: "#6A2A40",
                        marginBottom: 20,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Upload imagem
                    </h2>
                  )}
                </>
              )}
            </div>
            <input
              type="file"
              onChange={handleUploadImageProfile}
              ref={fileInputleRef}
              style={{ display: "none" }}
            />
          </Form.Item>
          <Form.Item
            label="Nome"
            name="name"
            rules={[{ required: true, message: "Inserir o nome do produto" }]}
          >
            <Input style={stylesInput} />
          </Form.Item>
          <Form.Item
            label="Descrição"
            name="description"
            rules={[
              { required: true, message: "Inserir a descrição do produto" },
            ]}
          >
            <Input style={stylesInput} />
          </Form.Item>
          <Form.Item
            label="Codigo"
            name="collibri_id"
            rules={[
              {
                required: false,
                message: "Inserir o código colibri do produto",
              },
            ]}
          >
            <Input style={stylesInput} />
          </Form.Item>
          <Form.Item
            label="Categoria"
            name="category"
            rules={[
              { required: true, message: "Por favor, selecione uma categoria" },
            ]}
          >
            <Select placeholder="Selecione uma categoria" style={stylesInput}>
              {categories.map((category) => (
                <Select.Option key={category.id} value={category.id}>
                  {category.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <hr />

          <div>
            <strong>Complementos:</strong>
            {isBlocked ? (
              <p style={{ color: "red" }}>
                <strong>
                  Não pode adicionar complementos enquanto o produto estiver
                  bloqueado
                </strong>
              </p>
            ) : (
              <p></p>
            )}
          </div>
          <Form.List name="complements">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...field }, index) => (
                  <Space key={key} align="baseline">
                    <Form.Item
                      {...field}
                      name={[name, "name"]}
                      label="Nome"
                      rules={[
                        {
                          required: true,
                          message: "Adicione o nome do complemento",
                        },
                      ]}
                    >
                      <Input readOnly/>
                    </Form.Item>
                    <Form.Item
                      {...field}
                      name={[name, "price"]}
                      label="Preço"
                      rules={[
                        {
                          required: true,
                          message: "Adicione o preço do complemento",
                        },
                      ]}
                    >
                      <InputNumber
                        style={stylesInput}
                        step="0.01"
                        prefix="R$"
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                        }
                        parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
                      />
                    </Form.Item>
                    <Form.Item
                      {...field}
                      name={[name, "status"]}
                      label="Status"
                    >
                      <Switch
                        checked={
                          Formins.getFieldValue([
                            "complements",
                            index,
                            "status",
                          ]) === "active"
                        }
                        onChange={(checked) => {
                          const newStatus = checked ? "active" : "inactive";
                          const complements =
                            Formins.getFieldValue("complements");
                          const updatedComplements = complements.map(
                            (item: any, idx: any) => {
                              if (idx === index) {
                                return { ...item, status: newStatus };
                              }
                              return item;
                            }
                          );
                          Formins.setFieldsValue({
                            complements: updatedComplements,
                          });

                          console.log(
                            "Updated complements at index",
                            index,
                            "to",
                            newStatus
                          );
                        }}
                      />
                    </Form.Item>
                    <MinusCircleOutlined
                      onClick={() => {
                        remove(name);
                      }}
                      rev={undefined}
                    />
                  </Space>
                ))}
              </>
            )}
          </Form.List>
          <>
            {!isBlocked ? (
              <div
                className="create_product_form_dropdown_box"
                style={{ margin: "30px" }}
              >
                <select
                  id="dropdown"
                  onChange={(event) => onChangeSelect(event, "complement")}
                  value={selectedComplement}
                >
                  <option value="">
                    Selecione um Complemento para vincular
                  </option>
                  {complementsProducts.map((product) => {
                    const disabled = validatedOptionDisabled(product);
                    return (
                      <option
                        key={product.id}
                        value={product.id}
                        disabled={disabled}
                      >
                        {product.category} - {product.name}
                      </option>
                    );
                  })}
                </select>

                <button
                  type="button"
                  onClick={showModal}
                  className="button_products"
                >
                  <img src={plusIcon} alt="" />
                </button>
              </div>
            ) : (
              <div></div>
            )}
          </>
          <div style={{ display: "flex", gap: 15 }}>
            <Form.Item label="Máximo de Complementos" name="max_complement">
              <InputNumber style={stylesInput} />
            </Form.Item>
            <Form.Item label="Mínimo de Complementos" name="min_complement">
              <InputNumber style={stylesInput} />
            </Form.Item>
          </div>
          <hr />
          <div>
            <strong>Adicionais:</strong>
            {isBlocked ? (
              <p style={{ color: "red" }}>
                <strong>
                  Não pode adicionar complementos enquanto o produto estiver
                  bloqueado
                </strong>
              </p>
            ) : (
              <p></p>
            )}
          </div>
          <Form.List name="additionals">
            {(fields, { add, remove }) => (
              <>
                {fields.map(
                  ({ key, name, ...field }, index) => (
                    (
                      <Space key={key} align="baseline">
                        <Form.Item
                          {...field}
                          name={[name, "name"]}
                          label="Nome"
                          rules={[
                            {
                              required: true,
                              message: "Adicione o nome do adicional",
                            },
                          ]}
                        >
                          <Input readOnly/>
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[name, "price"]}
                          label="Preço"
                          rules={[
                            {
                              required: true,
                              message: "Adicione o preço do adicional",
                            },
                          ]}
                        >
                          <InputNumber
                            style={stylesInput}
                            step="0.01"
                            prefix="R$"
                            formatter={(value) =>
                              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                            }
                            parser={(value) =>
                              value!.replace(/\$\s?|(,*)/g, "")
                            }
                            
                          />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[name, "status"]}
                          label="Status"
                        >
                          <Switch
                            checked={
                              Formins.getFieldValue([
                                "additionals",
                                index,
                                "status",
                              ]) === "active"
                            }
                            onChange={(checked) => {
                              const newStatus = checked ? "active" : "inactive";
                              const additionals =
                                Formins.getFieldValue("additionals");
                              const updatedAdditionals = additionals.map(
                                (item: any, idx: any) => {
                                  if (idx === index) {
                                    return { ...item, status: newStatus };
                                  }
                                  return item;
                                }
                              );
                              Formins.setFieldsValue({
                                additionals: updatedAdditionals,
                              });

                              console.log(
                                "Updated additionals at index",
                                index,
                                "to",
                                newStatus
                              );
                            }}
                          />
                        </Form.Item>
                        <MinusCircleOutlined
                          onClick={() => {
                            remove(name);
                          }}
                          rev={undefined}
                        />
                      </Space>
                    )
                  )
                )}
              </>
            )}
          </Form.List>

          <>
            {!isBlocked ? (
              <div
                className="create_product_form_dropdown_box"
                style={{ margin: "30px" }}
              >
                <select
                  id="dropdown"
                  onChange={(event) => onChangeSelect(event, "additional")}
                  value={selectedAdditional}
                >
                  <option value="">Selecione um Adicional para vincular</option>
                  {additionalsProducts.map((product) => {
                    const disabled = validatedOptionDisabled(product);

                    return (
                      <option
                        key={product.id}
                        value={product.id}
                        disabled={disabled}
                      >
                        {product.category} - {product.name}
                      </option>
                    );
                  })}
                </select>

                <button
                  type="button"
                  onClick={showModal}
                  className="button_products"
                >
                  <img src={plusIcon} alt="" />
                </button>
                <Modal
                  title="Adicionar Produto"
                  open={isModalOpen}
                  onOk={handleOk}
                  onCancel={handleCancel}
                  okButtonProps={{ disabled: true, hidden: true }}
                  cancelButtonProps={{ disabled: true, hidden: true }}
                >
                  <div>
                    <CreateProductComponent />
                  </div>
                </Modal>
              </div>
            ) : (
              <div></div>
            )}
          </>
          <div style={{ display: "flex", gap: 15 }}>
            <Form.Item label="Máximo de Adicionais" name="max_additional">
              <InputNumber style={stylesInput} />
            </Form.Item>
            <Form.Item label="Mínimo de Adicionais" name="min_additional">
              <InputNumber style={stylesInput} />
            </Form.Item>
          </div>
          <hr />
          {!loadInfoShowcase && (
            <>
              <Form.Item label="Disponibilidade por dia:">
                <div
                  style={{
                    gap: 2,
                    display: "felx",
                    justifyContent: "center",
                    alignItems: "center",
                    maxWidth: "450px",
                  }}
                >
                  {days.map((day) => (
                    <Space
                      key={day.label}
                      align="baseline"
                      style={{ padding: 5 }}
                    >
                      <Checkbox
                        checked={showcaseData.weekday ? showcaseData.weekday.includes(day.value) : false}
                        onChange={(e) => {
                          handleCheckboxChange(day.value, e.target.checked);
                        }}
                      />
                      {day.label}
                    </Space>
                  ))}
                </div>
              </Form.Item>
              <Form.Item
                label="Disponibilidade por horário:"
                style={{ display: "flex", gap: "5px" }}
              >
                <Form.Item
                  name="start"
                  label="Início"
                  rules={[
                    {
                      required: true,
                      message: "Por favor, selecione o horário de início!",
                    },
                  ]}
                  style={{
                    display: "inline-block",
                    width: "calc(50%)",
                    marginRight: "10px",
                  }}
                  initialValue={showcaseData.start}
                >
                  <Input type="time" step="1" placeholder="Início" onChange={(e) => setShowCaseData({...showcaseData, start: e.target.value})}/>
                </Form.Item>

                <Form.Item
                  name="end"
                  label="Fim"
                  rules={[
                    {
                      required: true,
                      message: "Por favor, selecione o horário de fim!",
                    },
                  ]}
                  initialValue={showcaseData.end}
                  style={{ display: "inline-block", width: "calc(50%)" }}
                >
                  <Input type="time" step="1" placeholder="Fim"  onChange={(e) => setShowCaseData({...showcaseData, end: e.target.value})}/>
                </Form.Item>
              </Form.Item>
            </>
          )}
          <hr />

          <Form.Item wrapperCol={{ offset: 8 }}>
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: "#6A2A40",
                  fontSize: 18,
                  fontSizeSM: 20,
                  borderRadius: 20,
                  paddingContentHorizontal: 70,
                },
              }}
            >
              <Button loading={loading} type="primary" htmlType="submit">
                Salvar alterações
              </Button>
            </ConfigProvider>
          </Form.Item>
        </Form>
      </Form.Provider>
    </>
  );
}
